import React from 'react';
import {View} from 'react-native';
import {Text} from '../../../shared/components/text';
import {Checkbox} from '../../../shared/components/baseField/components/checkbox/checkbox';
import {Button} from '../../../shared/components/button';
import {useTheme} from '../../../shared/theme';
import {useIsSmallScreenDevice} from '../../../shared/hooks/useIsSmallScreenDevice';
import {useStyles} from '../../../shared/hooks/styles';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {DeviceSize} from '../../../shared/theme/helpers';
import {useCustomBackhandler} from '../../../shared/hooks/useCustomBackhandler';

type Props = {
  isEsiaProcessingAccepted: boolean;
  setIsEsiaProcessingAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  onButtonPress: () => void;
};
export default (props: Props) => {
  const {isEsiaProcessingAccepted, setIsEsiaProcessingAccepted, onButtonPress} = props;
  const theme = useTheme();
  const isDesktopSize = useIsDesktop();
  const isSmallScreen = useIsSmallScreenDevice();
  useCustomBackhandler();
  const styles = useStyles(({isDesktop, mediaOnly}) => {
    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        paddingHorizontal: isDesktop ? 0 : 16,
      },
      textCenter: {
        textAlign: 'center',
      },
      hlpText: {
        color: theme.helpText.color,
        marginTop: 18,
        marginBottom: 24,
        marginHorizontal: 24,
      },
      btn: {
        marginBottom: isDesktop ? 40 : isSmallScreen ? 0 : 10,
        width: '100%',
        textAlign: 'center',
        padding: isSmallScreen ? 0 : 6,
      },
      infoText: {
        marginTop: isSmallScreen ? 20 : 24,
      },
      checkbox: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginVertical: isSmallScreen ? 10 : 24,
        marginHorizontal: isDesktop ? 0 : 24,
        '&:hover': {
          cursor: 'pointer',
        },
      },
      checkboxBtn: {
        marginTop: 12,
        marginRight: 12,
        marginLeft: 12,
      },
      agreementText: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.bodySmallLight, {
          ...theme.fonts.label,
          lineHeight: 24,
        }),
      },
    };
  }, []);
  return (
    <View style={styles.root}>
      <Text style={[styles.textCenter, styles.infoText]} type={isDesktopSize ? 'body' : 'caption'}>
        Для подачи заявления на получение нефинансовой ЕСК необходимо заполнить данные с портала госуслуги
      </Text>
      <View style={styles.checkbox}>
        <Checkbox
          style={styles.checkboxBtn}
          testIDprefix='esia-reg-card-form-submit'
          value={isEsiaProcessingAccepted}
          onChange={() => setIsEsiaProcessingAccepted(!isEsiaProcessingAccepted)}
        />
        <Text style={styles.agreementText} onPress={() => setIsEsiaProcessingAccepted(!isEsiaProcessingAccepted)}>
          Подтверждаю запрос и обработку персональных данных с портала госуслуги
        </Text>
      </View>
      <Button
        id='esia_reg_card'
        type='secondary'
        text={isDesktopSize ? 'Оформить нефинансовую карту' : 'Оформить карту'}
        style={styles.btn}
        onPress={onButtonPress}
        disabled={!isEsiaProcessingAccepted}
      />
      <Text style={[styles.textCenter, styles.infoText]} type={isDesktopSize ? 'body' : 'caption'}>
        Если хотите оформить финансовую карту, Вам необходимо обратиться в любой банк-партнёр Единой социальной карты.
      </Text>
    </View>
  );
};
